import {useState, useEffect} from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Select,
  message,
  Upload,
} from 'antd';
import {useDispatch} from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {createCategory, updateCategory} from '../../../redux/slices/categoriesPuntoVenta';
import {normFile, beforeUpload, dummyRequest} from '../../../utils/images';
import Close from '../../../components/Close';
import styles from '../styles/Editor.module.css';

const {Option} = Select;

const Editor = ({close, category, handleCategory}) => {
  const [sending, handleSending] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    const initialFetch = async () => {
      if (category) {
        const newValues = {
          name: category.type
        };
        form.setFieldsValue(newValues);
      }
    };
    initialFetch();
  }, [category]);

  const save = async () => {
    try {
      handleSending(true);
      const values = await form.validateFields();
      const info = {};
      if (category) {
        info.id = category.id
      }
      info.name = values.name
    
      if (category) {
        const response = await dispatch(updateCategory(category.id, info));
        if (response.status === 'success') {
          message.success('Cambios realizados con éxito');
          close()
        } else if (response.type === 'incomplete') {
          handleSending(false);
          message.warning('Ingresa todos los datos');
        } else {
          message.error('¡Hubo un problema! Inténtalo de nuevo');
        }
      } else {
        const response = await dispatch(createCategory(info));
        if (response.status === 'success') {
          message.success('Cambios realizados con éxito');
          handleCategory(response.category);
          close()
        } else if (response.type === 'incomplete') {
          handleSending(false);
          message.warning('Ingresa todos los datos');
        } else {
          message.error('¡Hubo un problema! Inténtalo de nuevo');
        }
      }
      handleSending(false);
    } catch (e) {
      message.error('¡Hubo un problema! Inténtalo de nuevo');
    }
  };

  return (
    <div className={styles.editor}>
      <div className={styles.header}>
        <span className={styles.title}>
          {category ? 'Editar categoría' : 'Nueva categoría'}
        </span>
        <Close action={close} />
      </div>
      <Form
        name="branch-editor"
        autoComplete="off"
        form={form}
        colon={false}
        requiredMark={false}
        onFinish={save}
        className={styles.form}
      >
        <Row gutter={20}>
          <Col span={24}>
            <Form.Item
              label={
                <span className={styles.label}>
                  NOMBRE
                </span>
              }
              name="name"
              className={styles.itemColumn}
              rules={[{required: true, message: 'Ingresar nombre'}]}
            >
              <Input size="large" className={styles.input} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item className={styles.itemSubmit}>
              <Button
                loading={sending}
                className={styles.submit}
                size="large"
                type="primary"
                htmlType="submit">
                GUARDAR CATEGORÍA
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default Editor;
